module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "mini-size",
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表",
      "size": "small",
      "disabled": !_vm.filters.IsAdmin
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.WID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "WID", $$v)
      },
      expression: "filters.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "货主",
      "size": "small"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.OwnerID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "OwnerID", $$v)
      },
      expression: "filters.OwnerID"
    }
  }, _vm._l((_vm.ownerList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "库存编码/包裹编码",
      "size": "small"
    },
    model: {
      value: (_vm.filters.KeyWord),
      callback: function($$v) {
        _vm.$set(_vm.filters, "KeyWord", $$v)
      },
      expression: "filters.KeyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    attrs: {
      "size": "small",
      "fetch-suggestions": _vm.querySearchSpu,
      "placeholder": "SPU / Name / SkuID"
    },
    on: {
      "select": _vm.handleSelectSpu
    },
    model: {
      value: (_vm.spuName),
      callback: function($$v) {
        _vm.spuName = $$v
      },
      expression: "spuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name"
    },
    on: {
      "select": _vm.handleSelectSearch
    },
    model: {
      value: (_vm.skuName),
      callback: function($$v) {
        _vm.skuName = $$v
      },
      expression: "skuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "id": "pdfDom",
      "data": _vm.WQCFlow,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "sortable": "",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作类型",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.QC.Types))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存编码/包裹编码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Stock.OrderID)), _c('br'), _vm._v(_vm._s(scope.row.Package.FreightNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含产品",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.Package.Product), function(p) {
          return _c('p', [_vm._v("[" + _vm._s(p.Product.Status) + "] [" + _vm._s(p.Product.FullName) + "] " + _vm._s(p.Product.FullSKU) + " * " + _vm._s(p.Product.Quantity))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作数量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.QC.Quantity))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数据流向",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Stock.Rcode) + " -> " + _vm._s(scope.row.MoveToStock.Rcode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "prop": "",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.User.TrueName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("cutDate")(scope.row.Date)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-sizes": [20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-398c4a5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/qualityControl/WQCFlow.vue
// module id = 836
// module chunks = 1